
<template>
    <div id="ambis-meter-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Meter',
                    to: { path: '/ambis-meter' },
                },
                { text: 'Tambah Ambis Meter' },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ "Tambah Ambis Meter" }}
        </h3>

        <v-card>
            <v-stepper v-model="step" flat class="pa-0" color="blew">
                <v-card-text>
                    <v-stepper-header flat style="box-shadow: none">
                        <v-stepper-step :complete="step > 1" step="1">
                            Periode
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="step > 2" step="2">
                            Kelas dan Misi
                        </v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="3"> Level </v-stepper-step>
                    </v-stepper-header>
                </v-card-text>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <app-periodeform
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <app-missionform
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <app-levelform
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                        ></app-levelform>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card>
    </div>
</template>

<script>
import PeriodeForm from "@/modules/ambis_meter/components/PeriodeForm";
import MissionForm from "@/modules/ambis_meter/components/MissionForm";
import LevelForm from "@/modules/ambis_meter/components/LevelForm";

export default {
    name: "ambis-meter-form",

    components: {
        "app-periodeform": PeriodeForm,
        "app-missionform": MissionForm,
        "app-levelform": LevelForm,
    },

    data: function () {
        return {
            step: 1,
            stepName: ["Periode", "Kelas dan Misi", "Level"],
        };
    },

    methods: {
        goToNextStep: function () {
            if (this.step === 3) {
                this.$store.commit("showAlert", {
                    message: `Berhasil menyimpan data`,
                    type: "success",
                });
                return this.$router.push({ path: "/ambis-meter" });
            }
            this.step++;
        },
    },
};
</script>



// WEBPACK FOOTER //
// AmbisMeterForm.vue?422697f6